import { render, staticRenderFns } from "./CreatorCampaigns.vue?vue&type=template&id=61c0854a&scoped=true&"
import script from "./CreatorCampaigns.vue?vue&type=script&lang=js&"
export * from "./CreatorCampaigns.vue?vue&type=script&lang=js&"
import style0 from "./CreatorCampaigns.vue?vue&type=style&index=0&id=61c0854a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c0854a",
  null
  
)

export default component.exports